// @flow

import _ from 'lodash';

import type { FontState, FontAction } from 'stores/flow-type/font.type';

import {
  GET_FONT_LIST_REQUEST,
  GET_FONT_LIST_SUCCESS,
  GET_FONT_LIST_FAILURE
} from 'stores/flow-type/font.type';

const initialState: FontState = {
  fontListLoading: false,
  fontListSuccess: false,
  error: undefined,
  fontList: []
};

const fontReducers = (state: FontState = initialState, action: FontAction) => {
  switch (action.type) {
    case GET_FONT_LIST_REQUEST:
      return { ...state, fontListLoading: true, fontListSuccess: false };
    case GET_FONT_LIST_SUCCESS: {
      let { data: dataPayload = {} } = action.payload;

      let { data = [] } = dataPayload;
      // const fontList = _.map(fonts, name => ({ value: name, label: name }));
      const fontList = data;
      const fontFamily = _.map(fontList, font => {
        return { value: font.family, label: font.family };
      });

      return {
        ...state,
        fontListLoading: false,
        fontListSuccess: true,
        error: undefined,
        fontList,
        fontFamily
      };
    }
    case GET_FONT_LIST_FAILURE:
      return {
        ...state,
        fontList: [],
        fontListLoading: false,
        fontListSuccess: false,
        error: action.payload
      };
    default:
      return state;
  }
};
export default fontReducers;
